import React from 'react';
import classNames from "./InteractiveRequestId.module.css"
import { SetObjectToDisplayAsJson } from "./JsonOverlayView";
import { observer } from 'mobx-react-lite';
import { HasGetObjectByRequestId } from "../../State/EvidenceDB/HasGetObjectByRequestId";



export type InteractiveRequestIdBaseProps = SetObjectToDisplayAsJson & HasGetObjectByRequestId;

export const InteractiveRequestId = observer ( ({
	setObjectToDisplayAsJson,
	requestId,
	requestGetter
}: InteractiveRequestIdBaseProps & {requestId: string}) => {
	const onClick = async (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		const objectToDisplay = (await requestGetter?.getAsync(requestId));
		console.log(`Object to display`, objectToDisplay);
		setObjectToDisplayAsJson?.(objectToDisplay);
	};
	return (
		<a href="#" className={classNames.InteractiveRequestIdElement} data-request-id={requestId} onClick={onClick}>{requestId}</a>
	);
});